module.exports = __webpack_public_path__ + "img/4-(7).7ac8cd34.jpg";